export var localizations = {
  name: {
    en: "Block Puzzle: Mastery Strategy",
    ru: "Блок Пазл: Стратегия Мастерства",
  },
  level: {
    en: "Level",
    ru: "Уровень",
  },
  score: {
    en: "Score",
    ru: "Счет",
  },
  newGame: {
    en: "A new game",
    ru: "Новая игра",
  },
  pause: {
    en: "Pause",
    ru: "Пауза",
  },
  continue: {
    en: "Continue",
    ru: "Продолжить",
  },
  startOver: {
    en: "Start over",
    ru: "Начать сначала",
  },
  congratulations: {
    en: "Congratulations",
    ru: "Поздравляю",
  },
};

export var getLanguage = function () {
  if (!window.ysdk) {
    return "en";
  } else {
    var language = window.ysdk.environment.i18n.lang;
    if (language !== "en" && language !== "ru") {
      return "en";
    } else {
      return language;
    }
  }
};
